import { z } from 'zod';

const iGuideEntrySchema = z.object({
  currentTaskId: z.string().optional(),
  answers: z.record(z.string(), z.union([z.record(z.string(), z.string()), z.null(), z.undefined()])).default({})
});

export { iGuideEntrySchema };
//# sourceMappingURL=i-guide.entry-data.js.map
